<!-- myCartModal USDC Modal -->
<div class="modal-dialog modal-dialog-centered mail-modal myCartModal" *ngIf="!showBuyConfirm">
    <div class="modal-content">

        <div class="modal-header">
            <h2>My cart</h2>
            <button class="cartclose-btn" type="button" (click)="closemyCartModal()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M17.707 6L5.70784 17.9992M17.7062 18L5.70703 6.00085" stroke="#72798B" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>
        <div class="modal-body-wrap" *ngIf="cartData">
            <div class="modal-body-top">
                <h3>Total assets in cart <span>({{cartData.length}} Assets)</span></h3>
                <button (click)="removeItem('all')">Remove all</button>
            </div>
            <div class="modal-body">
                <ng-container *ngFor="let item of cartData; let i = index">
                    <div class="cart-items">
                        <div class="cart-item-title position-relative">
                            <div class="d-flex align-items-center gap-3"
                                [ngStyle]="{ opacity: item?.is_active ? '1' : '0.4' }">
                                <span>
                                    <img [src]="item.sell_order_id.nft.primary_media | pinataThumbnail: 320" alt="cart-image" appImageFallback />
                                </span>
                                <h3>{{item.sell_order_id.nft.name}}</h3>
                            </div>
                            <h6 class="text-danger" *ngIf="!item?.is_active">(Asset no longer available.)</h6>
                            <h6 class="text-danger" *ngIf="item?.is_active && item?.sell_order_id?.nft?.is_frozen">(Asset frozen by admin.)</h6>
                        </div>
                        <div class="cart-price">
                            <p [ngStyle]="{ opacity: item?.is_active ? '1' : '0.4' }">
                                {{item.sell_order_id.price}} {{item.sell_order_id.currency.display_symbol}}</p>
                            <button (click)="removeItem(item._id)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path
                                        d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5"
                                        stroke="url(#paint0_linear_1391_1115)" stroke-width="1.5"
                                        stroke-linecap="round" />
                                    <path
                                        d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5"
                                        stroke="url(#paint1_linear_1391_1115)" stroke-width="1.5"
                                        stroke-linecap="round" />
                                    <path d="M9.5 16.5V10.5" stroke="url(#paint2_linear_1391_1115)" stroke-width="1.5"
                                        stroke-linecap="round" />
                                    <path d="M14.5 16.5V10.5" stroke="url(#paint3_linear_1391_1115)" stroke-width="1.5"
                                        stroke-linecap="round" />
                                    <defs>
                                        <linearGradient id="paint0_linear_1391_1115" x1="19.7906" y1="13.75"
                                            x2="4.17737" y2="13.75" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="currentColor" />
                                            <stop offset="1" stop-color="currentColor" />
                                        </linearGradient>
                                        <linearGradient id="paint1_linear_1391_1115" x1="21.3487" y1="3.75" x2="2.61285"
                                            y2="3.75" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="currentColor" />
                                            <stop offset="1" stop-color="currentColor" />
                                        </linearGradient>
                                        <linearGradient id="paint2_linear_1391_1115" x1="10.5194" y1="13.5" x2="9.47849"
                                            y2="13.5" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="currentColor" />
                                            <stop offset="1" stop-color="currentColor" />
                                        </linearGradient>
                                        <linearGradient id="paint3_linear_1391_1115" x1="15.5194" y1="13.5" x2="14.4785"
                                            y2="13.5" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="currentColor" />
                                            <stop offset="1" stop-color="currentColor" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button>
                        </div>

                    </div>
                </ng-container>
            </div>
            <!-- ======================== Removal CONFIRMATION POPUP ======================== -->
            <div *ngIf="showRemoveConfirm" class="update-popup-backdrop">
                <div class="update-popup animated-popup">
                    <span class="d-block mb-3">
                        <img src="assets/images/new-update.svg" alt="new-update">
                    </span>
                    <h3>Remove {{removeItemId == 'all' ? 'all' : 'asset'}}</h3>
                    <p class="subtitle">Are you sure you want to remove {{removeItemId == 'all' ? 'all' : 'this'}} asset
                        from your cart ?</p>

                    <div class="popup-buttons">
                        <button class="later-btn" [disabled]="isRemoving" (click)="cancelRemove()">Cancel</button>
                        <button class="refresh-btn" [disabled]="isRemoving" (click)="confirmRemove()">
                            {{ isRemoving ? 'Removing...' : 'Confirm' }}
                        </button>
                    </div>

                </div>
            </div>
            <div class="modal-total">
                <ul>
                    <li>
                        Total asset value
                        <span>{{ totalItemValue | number }} {{ currencySymbol }}</span>
                    </li>
                </ul>
                <p>{{ getPlatformFeeText() }}</p>
                <p class="text-danger" *ngIf="hasInactiveItems">
                    Please remove inactive assets before proceeding with the purchase.
                </p>

            </div>
            <div class="modal-footer px-0">
                <div class="row w-100 flex-column flex-sm-row">
                    <div class="col-4 ps-sm-0 mb-3 mb-sm-0 addmore_btn_wrap">
                        <button class="addmore_btn w-100" (click)="addMoreItems()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                fill="none">
                                <path
                                    d="M6.66602 13.3333L13.9328 12.7277C16.2065 12.5383 16.7169 12.0416 16.9689 9.77403L17.1932 6.97729"
                                    stroke="url(#paint0_linear_1149_7887)" stroke-linecap="round" />
                                <path d="M5 5H9.49149" stroke="url(#paint1_linear_1149_7887)" stroke-linecap="round" />
                                <path
                                    d="M5.00065 18.3333C5.92113 18.3333 6.66732 17.5871 6.66732 16.6667C6.66732 15.7462 5.92113 15 5.00065 15C4.08018 15 3.33398 15.7462 3.33398 16.6667C3.33398 17.5871 4.08018 18.3333 5.00065 18.3333Z"
                                    stroke="url(#paint2_linear_1149_7887)" />
                                <path
                                    d="M14.1667 18.3333C15.0871 18.3333 15.8333 17.5871 15.8333 16.6667C15.8333 15.7462 15.0871 15 14.1667 15C13.2462 15 12.5 15.7462 12.5 16.6667C12.5 17.5871 13.2462 18.3333 14.1667 18.3333Z"
                                    stroke="url(#paint3_linear_1149_7887)" />
                                <path d="M6.66602 16.6666H12.4993" stroke="url(#paint4_linear_1149_7887)"
                                    stroke-linecap="round" />
                                <path
                                    d="M1.66602 1.66663H2.47102C3.25825 1.66663 3.94447 2.18712 4.1354 2.92907L6.61478 12.5637C6.74007 13.0506 6.63285 13.5664 6.32288 13.968L5.52612 15"
                                    stroke="url(#paint5_linear_1149_7887)" stroke-linecap="round" />
                                <path d="M14.166 2.36963V7.63043" stroke="url(#paint6_linear_1149_7887)"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11.5371 5H16.7979" stroke="url(#paint7_linear_1149_7887)"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <defs>
                                    <linearGradient id="paint0_linear_1149_7887" x1="17.3972" y1="10.1553" x2="6.43959"
                                        y2="10.1553" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="currentColor" />
                                        <stop offset="1" stop-color="currentColor" />
                                    </linearGradient>
                                    <linearGradient id="paint1_linear_1149_7887" x1="9.5785" y1="5.5" x2="4.90339"
                                        y2="5.5" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="currentColor" />
                                        <stop offset="1" stop-color="currentColor" />
                                    </linearGradient>
                                    <linearGradient id="paint2_linear_1149_7887" x1="6.73189" y1="16.6667" x2="3.26229"
                                        y2="16.6667" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="currentColor" />
                                        <stop offset="1" stop-color="currentColor" />
                                    </linearGradient>
                                    <linearGradient id="paint3_linear_1149_7887" x1="15.8979" y1="16.6667" x2="12.4283"
                                        y2="16.6667" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="currentColor" />
                                        <stop offset="1" stop-color="currentColor" />
                                    </linearGradient>
                                    <linearGradient id="paint4_linear_1149_7887" x1="12.6124" y1="17.1666" x2="6.54055"
                                        y2="17.1666" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="currentColor" />
                                        <stop offset="1" stop-color="currentColor" />
                                    </linearGradient>
                                    <linearGradient id="paint5_linear_1149_7887" x1="6.76288" y1="8.33329" x2="1.55847"
                                        y2="8.33329" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="currentColor" />
                                        <stop offset="1" stop-color="currentColor" />
                                    </linearGradient>
                                    <linearGradient id="paint6_linear_1149_7887" x1="15.1854" y1="5.00003" x2="14.1445"
                                        y2="5.00003" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="currentColor" />
                                        <stop offset="1" stop-color="currentColor" />
                                    </linearGradient>
                                    <linearGradient id="paint7_linear_1149_7887" x1="14.1675" y1="3.98063" x2="14.1675"
                                        y2="5.02151" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="currentColor" />
                                        <stop offset="1" stop-color="currentColor" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            Add more
                        </button>
                    </div>
                    <div class="col-8 pe-sm-0 buy_btn_wrap">
                        <button type="button" class="buy_btn w-100"
                            [ngStyle]="{ opacity: hasInactiveItems ? '0.4' : '1' }" (click)="buyNftOrder()"
                            [disabled]="isBuyNowProcessing || hasInactiveItems">
                            {{ isBuyNowProcessing ? 'Processing...' : 'Buy now.'}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- mail verification modal start -->
<div class="modal fade" [config]="{backdrop: 'static', keyboard: false}" bsModal #verificationModal="bs-modal"
    tabindex="-1" role="dialog">
    <app-mailverfication (closeModal)="verificationModal.hide()"
        (openModal)="verificationModal.show()"></app-mailverfication>
</div>
<!-- mail verification modal end -->

<!-- Confirmation Modal -->
<div class="modal fade" [config]="{backdrop: 'static', keyboard: false}" bsModal #confirmationModal="bs-modal"
    tabindex="-1" role="dialog">
    <!-- Need to handle Processing States for confirmation modal closure -->
    <app-confirmation-modal [progressData]="progressData" [confirmationData]="confirmationData"
        (closeModal)="onConfirmationModalClosure()" [loanRequestData]="getFormData()"
        (confirmPurchase)="confirmBulkPurchase()" [modalRef]="confirmationModal"
        [showEstimation]="true" [hasInactiveItems]="hasInactiveItems"></app-confirmation-modal>
</div>
